import React from 'react';
import { Button, DangerText, ISelectOption, Select } from 'ui-toolkit';
import { IDisbursementFormData } from 'types/order/escrow/IDisbursementFormData';

interface IDisbursementTypeSelectorProps {
  data: IDisbursementFormData;
  disbursementMethodOptions: ISelectOption[];
  isTypeLocked: boolean;
  isReadOnly: boolean;
  onTypeChange: (option: ISelectOption) => void;
  onToggleLock: () => void;
}

export const DisbursementTypeSelector: React.FC<IDisbursementTypeSelectorProps> = ({
  data,
  disbursementMethodOptions,
  isTypeLocked,
  isReadOnly,
  onTypeChange,
  onToggleLock,
}) => {
  return (
    <Select
      className={'grow basis-1/3'}
      options={disbursementMethodOptions}
      label={'Disbursement Method'}
      action={
        <>
          {!data.isNew && !isReadOnly && (
            <Button isInline intent={'ghost'} onClick={onToggleLock}>
              <DangerText>{isTypeLocked ? 'Unlock' : 'Lock'}</DangerText>
            </Button>
          )}
        </>
      }
      placeholder={'Select...'}
      value={disbursementMethodOptions.find((t) => t.value === data.type)}
      onChange={onTypeChange}
      isRequired
      isDisabled={(isTypeLocked && !data.isNew) || isReadOnly}
    />
  );
};
